import { useMemo } from 'react';
import { useUserContext } from '../../../context/UserContext';
import { RoomObjectType, RoomPlacingModel } from '../../../types/room';
import Dialog from './Dialog';
import { useConfigurationContext } from '../../../context/ConfigurationContext';

const PlaceRoomDialog = ({
  nftBeingPlaced,
  handleAcceptPlacingNFT,
  onCancel,
}: {
  nftBeingPlaced: RoomObjectType;
  handleAcceptPlacingNFT: (model: RoomPlacingModel) => void;
  onCancel: () => void;
}) => {
  const { moveCost } = useConfigurationContext();
  const { user_name } = useUserContext();

  const [width, height] = useMemo(
    () => nftBeingPlaced.mapIconSize.split('x').map((v) => parseInt(v)),
    [nftBeingPlaced]
  );

  const nftPlacingModel: RoomPlacingModel = useMemo(
    () => ({
      widthX: width,
      heightZ: height,
      type: nftBeingPlaced.roomTypeId,
      moveCost: nftBeingPlaced.isPlaced ? moveCost : 0,
    }),
    [
      width,
      height,
      moveCost,
      nftBeingPlaced.isPlaced,
      nftBeingPlaced.roomTypeId,
    ]
  );

  return (
    <Dialog
      title="Place your room"
      onAccept={() => handleAcceptPlacingNFT(nftPlacingModel)}
      onClose={() => onCancel()}
      acceptText="Place room"
      closeText="Later"
    >
      <div style={{ textAlign: 'center' }}>
        Hello there, <b>{user_name}</b>!
      </div>
      <br />
      <br />
      <div style={{ textAlign: 'center' }}>
        {!nftBeingPlaced.isPlaced
          ? 'It looks like you have at least one room not yet placed in the Genesis Hotel. There might still be some special spots available in the hotel.'
          : `It looks like you want to move your room to another location in the hotel. Moving your room costs ${moveCost} credits.`}
      </div>
      <br />
      <br />
      <div style={{ textAlign: 'center' }}>
        Would you like to check out the room placement tool?{' '}
      </div>
    </Dialog>
  );
};

export default PlaceRoomDialog;
